import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { HttpClient } from '@angular/common/http';
import { filter, switchMap, map, catchError, take, defaultIfEmpty } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthStateService } from './auth-state.service';
import { TokenStorageService } from './token-storage.service';

export const authGuard: CanActivateFn = () => {
  const msalService = inject(MsalService);
  const msalBroadcastService = inject(MsalBroadcastService);
  const router = inject(Router);
  const http = inject(HttpClient);
  const authState = inject(AuthStateService);
  const tokenStorage = inject(TokenStorageService);

  return msalBroadcastService.inProgress$.pipe(
    filter((status) => status === InteractionStatus.None),
    take(1),
    switchMap(() => {
      const hasMsalAccount = msalService.instance.getAllAccounts().length > 0;
      const hasOtpSession = tokenStorage.hasSession();
      if (!hasMsalAccount && !hasOtpSession) {
        return of(router.createUrlTree(['/login']));
      }
      return http.get(`${environment.apiBaseUrl}/api/v1/health`).pipe(
        map(() => true),
        catchError((error) => {
          if (error.status === 403) {
            authState.setForbidden();
          } else if (error.status === 401) {
            authState.setUnauthorized();
          }
          if (error.status === 403 || error.status === 401) {
            msalService.instance.clearCache();
            tokenStorage.clear();
          }
          return of(router.createUrlTree(['/login']));
        }),
      );
    }),
    defaultIfEmpty(router.createUrlTree(['/login'])),
  );
};
